import { getMiniHostAppDetail } from 'mini-host-bridge/lib/getMiniHostAppDetail';
import { getCollectorUrl } from 'owa-analytics-utils';

/**
 * Gets the telemetry endpoint for the host app.
 *
 * Currently being used by host app - Outlook Lite.
 * If host app sends the telemetry config, we are using the telemetry endpoint sent by host app.
 *  - TelemetryEndpoint in miniHostappDetail contains valid url string for EUDB (European Union Data Boundary) case, otherwise undefined/null.
 *    So, for non-EUDB case, we are using the default telemetry collector endpoint used in Mini bypassing the EUDB check there.
 * In case, host app doesn't send the telemetry config (eg. older host app version), we are using the default telemetry collector endpoint used in Mini.
 */
export const getHostAppTelemetryEndpoint = () => {
    const telemetryConfig = getMiniHostAppDetail()?.telemetryConfig;
    const isTelemetryConfigSentFromHostApp = !!telemetryConfig;

    if (isTelemetryConfigSentFromHostApp) {
        return telemetryConfig.telemetryEndpoint || getCollectorUrl(true /* dontLogInEU */);
    }

    return getCollectorUrl();
};
